import {
  Sheet,
  SheetContent,
  SheetBody,
  SheetHeader,
  SheetTitle,
} from "@repo/ui/components/Base/Sheet";
import { Spinner } from "@repo/ui/components/Base/Spinner";
import { AgendaItemForm } from "./AgendaItemForm";
import { useGetAgendaItem } from "@/hooks/queryHooks/agendaItemHooks";

interface EditAgendaItemSheetProps {
  open: boolean;
  setOpen: (arg1: boolean) => void;
  tenantId: string;
  agendaItemId: string;
}
export const EditAgendaItemSheet = ({
  open,
  setOpen,
  tenantId,
  agendaItemId,
}: EditAgendaItemSheetProps) => {
  const { data: agendaItem } = useGetAgendaItem(tenantId, agendaItemId);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="overflow-y-auto" side="right">
        <SheetHeader>
          {!agendaItem && <Spinner />}
          {agendaItem && (
            <div>
              <SheetTitle>{`Edit ${agendaItem.name}`}</SheetTitle>
              <SheetBody>
                <AgendaItemForm
                  agendaItemFormData={agendaItem}
                  tenantId={tenantId}
                  handleCancel={() => setOpen(false)}
                  handleComplete={() => setOpen(false)}
                />
              </SheetBody>
            </div>
          )}
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};
